export const weatherThemes = {
  sunny: { icon: '☀', theme: { color: '#FFA820', backgroundColor: '#FFF8EE' }, imgUrl: '' },
  thunderstorm: {
    icon: '⛈',
    theme: { color: '#FFA820', backgroundColor: '#5B7294' },
    imgUrl:
      'https://emojipedia-us.s3.dualstack.us-west-1.amazonaws.com/thumbs/144/apple/325/cloud-with-lightning-and-rain_26c8-fe0f.png',
  },
  rain: {
    icon: '☔',
    theme: { color: '#B2DCFD', backgroundColor: '#5B7294' },
    imgUrl:
      'https://emojipedia-us.s3.dualstack.us-west-1.amazonaws.com/thumbs/144/apple/325/cloud-with-rain_1f327-fe0f.png',
  },
  clear: {
    icon: '☀',
    theme: { color: '#FFA820', backgroundColor: '#FFF8EE' },
    imgUrl:
      'https://emojipedia-us.s3.dualstack.us-west-1.amazonaws.com/thumbs/144/apple/325/sun_2600-fe0f.png',
  },
  drizzle: {
    icon: '🌦',
    theme: { color: '#838AA1', backgroundColor: '#A8CAFD' },
    imgUrl:
      'https://emojipedia-us.s3.dualstack.us-west-1.amazonaws.com/thumbs/144/apple/325/sun-behind-rain-cloud_1f326-fe0f.png',
  },
  snow: {
    icon: '☃',
    theme: { color: '#CCE9FF', backgroundColor: '#838AA1' },
    imgUrl:
      'https://emojipedia-us.s3.dualstack.us-west-1.amazonaws.com/thumbs/144/apple/325/snowman_2603-fe0f.png',
  },
  cloud: {
    icon: '☁',
    theme: { color: '#E1E1E1', backgroundColor: '#A8CAFD' },
    imgUrl:
      'https://emojipedia-us.s3.dualstack.us-west-1.amazonaws.com/thumbs/144/apple/325/cloud_2601-fe0f.png',
  },
  atmosphere: {
    icon: '🌫',
    theme: { color: '#7A7A7A', backgroundColor: '#C8C8C8' },
    imgUrl:
      'https://emojipedia-us.s3.dualstack.us-west-1.amazonaws.com/thumbs/144/apple/325/fog_1f32b-fe0f.png',
  },
};
// https://support.apple.com/en-gb/guide/iphone/iph4305794fb/ios

// night clear : https://help.apple.com/assets/6222428998C2CE34C75A5252/6222428B98C2CE34C75A5267/en_US/267eb826f049db26cb9f083e8f8919bb.png
// night cloudy : https://help.apple.com/assets/6222428998C2CE34C75A5252/6222428B98C2CE34C75A5267/en_US/96790352d02344a2a7c2c0c0763f2f61.png
